import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { DataTable } from "@/components/DataTable";
import { Text } from "@/components/Text";
import { IJobApplication } from "@/data/job-applications";
import { useFormats } from "@/hooks/Formats";

export interface IAssignmentRelatedJATableProps {
  jobApplication: IJobApplication;
  onRowClick?: (jobRequest: IJobApplication) => void;
}

export const AssignmentRelatedJATable: FC<IAssignmentRelatedJATableProps> = memo(({ jobApplication, onRowClick }) => {
  const { t } = useTranslation("session");
  const { formatDate } = useFormats();

  return (
    <DataTable<IJobApplication>
      onRowClick={onRowClick}
      data={[jobApplication]}
      columns={[
        {
          header: t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.JOB_APPLICATIONS.ID_TABLE_HEADER"),
          selector: (data: IJobApplication) => data.externalSystemId,
          flexGrow: 1,
          maxWidth: "100px",
        },
        {
          header: t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.JOB_APPLICATIONS.COMPANY_TABLE_HEADER"),
          selector: (data: IJobApplication) => (
            <Text wordBreak="word" whiteSpace="pre-wrap">
              {data.consultantProfile.sharedProfile?.company.name}
            </Text>
          ),
          flexGrow: 1,
        },
        {
          header: t("ASSIGNMENTS.DETAILS.RELATED_DETAILS.JOB_APPLICATIONS.SUBMISSION_DATE_TABLE_HEADER"),
          selector: (data: IJobApplication) => formatDate(data.createdDate),
          flexGrow: 1,
          maxWidth: "300px",
        },
      ]}
      uniqueKeyAccessor="id"
    />
  );
});
